import React from 'react';
import PropTypes from 'prop-types';
import { changeOpacity } from 'pages/response-sets/utils';

const CheckListFieldPreview = ({ field }) => {
  return (
    <div className='d-flex gap-3 flex-wrap'>
      {(field.properties?.basicProperties?.optionList ?? []).map((option, index) => (
        <div
          key={index}
          className='choice-list-option-box'
          style={{ backgroundColor: changeOpacity(option.itemColor, 20) }}
        >
          <label style={{ color: option.itemColor }}>{option.responseText}</label>
        </div>
      ))}
    </div>
  );
};

CheckListFieldPreview.propTypes = {
  field: PropTypes.object.isRequired,
};

export default CheckListFieldPreview;
